module.exports = __webpack_public_path__ + "media/images/flags/SA-ff7fa8fdb9c5b54eaa619f2caffe7697.svg";